export const styles = theme => ({
  root: {
    display: "flex",
    justifyContent: 'center',
    width: "90%",
    margin: "0 auto",
    backgroundColor: theme.palette.background.paper,
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    alignContent: "center",
    alignItems: 'flex-start',
    margin: '0 auto',
    width: 'fit-content',
    marginTop: theme.spacing.unit * 2,
    minWidth: 120,
  },
  monitors: {
    alignSelf: "center"
  },
  formControlLabel: {
    marginTop: theme.spacing.unit,
  },
  inputLabel: {
    marginTop: theme.spacing.unit,
  },
  select: {
    marginLeft: theme.spacing.unit
  },
  checkboxGroup: {
    display: "flex",
    justifyContent: "space-around"
  },
  dialogTitle: {
    display: "flex",
    justifyContent: "space-between"
  },
  sliderInactive: {
    display: "none"
  },
  container: {
    width: "100%",
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: "center"
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    minWidth: 200,
  },
  domainSettingsInputsContainer: {
    display: "flex",
    justifyContent: "flex-start"
  },
  hidden: {
    display: "none"
  },
  domainSettingsInputs: {
    marginRight: "20px",
    width: "100px"
  }
});



// WEBPACK FOOTER //
// ./src/styles/form-styles.js